import React from "react";

const AdmissionOpen = () => {
  return (
    <>
      <h2 style={{ textAlign: "center", marginBottom: "0px" }}>
        Admission Open
      </h2>
      <h3
        style={{ textAlign: "center", marginTop: "5px", marginBottom: "0px" }}
      >
        Master of Public Policy (MPP) Program
      </h3>
      <h4 style={{ textAlign: "center", marginTop: "5px" }}>
        School of Public Policy, University of Nepal
      </h4>

      <br />

      <p>
        The <strong>University of Nepal (UNepal)</strong> invites applications
        for the <strong>inaugural cohort</strong> of its first academic program,
        the <strong>Master of Public Policy (MPP)</strong>, commencing in{" "}
        <strong>February 2026</strong>.
      </p>

      <p>
        The MPP is a rigorous, interdisciplinary graduate program designed to
        prepare future policy professionals, analysts, managers, and leaders
        with strong analytical, problem-solving, and decision-making skills who
        can lead Nepal toward a brighter future.
      </p>

      <br />

      <h5>Program Summary</h5>
      <ul>
        <li>
          <strong>Degree:</strong> Master of Public Policy (MPP)
        </li>
        <li>
          <strong>Duration:</strong> Two years (four semesters)
        </li>
        <li>
          <strong>Mode of Study:</strong> Full-time
        </li>
        <li>
          <strong>Total Credits:</strong> 60
        </li>
        <li>
          <strong>Total Seats:</strong> 30 students
        </li>
      </ul>

      <br />

      <h5>Curriculum Highlights</h5>
      <p>
        The Master of Public Policy (MPP) program offers a carefully structured
        curriculum that integrates{" "}
        <strong>
          core courses, policy concentration courses, and electives
        </strong>{" "}
        to develop strong analytical, economic, and governance competencies. For
        details,{" "}
        <a href="https://unepal.edu.np/graduate">
          https://unepal.edu.np/graduate
        </a>
      </p>

      <br />

      <h5>Scholarships, Financial Assistance, and Fee Structure</h5>
      <p style={{ fontWeight: "bold" }}>
        Scholarships and Financial Aid (Guaranteed)
      </p>
      <p>
        The School of Public Policy is committed to attracting outstanding
        students with strong academic potential and leadership promise. For the
        inaugural cohort, the University will provide{" "}
        <strong>guaranteed scholarship</strong> (tuition support).
      </p>

      <ul>
        <li>
          <strong>Full Tuition Scholarships (Financial Aid): 5</strong>
          <br />
          Financial aid to cover full tuition fee will be awarded to the{" "}
          <strong>five most deserving students</strong>.
        </li>
        <li>
          <strong>Partial Scholarships: 5</strong>
          <br />
          An additional <strong>five students</strong> will receive partial
          scholarships covering <strong>75% of the tuition fee</strong>.
        </li>
        <li>
          <strong>Inaugural Batch Tuition Support Scholarship:</strong>
          <br />
          As this is the first cohort of the University of Nepal, all admitted
          students who do not receive full or partial scholarships will receive
          a{" "}
          <strong>
            tuition support scholarship covering 40% of the tuition fee
          </strong>
          .
        </li>
      </ul>

      <p style={{ fontWeight: "bold" }}>Program Fee</p>
      <ul>
        <li>
          <strong>Total Fee (two years):</strong> NPR 9,25,000
          <ul>
            <li>Admission fee: NPR 1,00,000</li>
            <li>Tuition fee: NPR 8,25,000</li>
          </ul>
        </li>
      </ul>

      <p style={{ fontWeight: "bold" }}>Scholarship Selection Criteria:</p>
      <p>
        Scholarships and financial assistance will be awarded based on{" "}
        <strong>academic merit, financial need, and inclusion criteria</strong>,
        with the aim of fostering a diverse and high-quality cohort.
      </p>

      <br />

      <h5>Application Eligibility</h5>
      <ul>
        <li>
          <strong>Academic Qualification:</strong>
          <br />A bachelor’s degree (minimum four-year duration) in any
          discipline from a university recognized by the University of Nepal.
          Applicants with master’s degree are also welcome to apply. Applicants
          from all academic backgrounds are encouraged to apply.
        </li>
      </ul>

      <br />

      <h5>Key Admission Dates</h5>
      <ul>
        <li>
          <strong>Application Deadline:</strong> January 22, 2026 (Magh 8, 2082)
        </li>
        <li>
          <strong>Entrance Examination / Interview:</strong> January 25–27, 2026
          (Detailed information will be communicated by email)
        </li>
        <li>
          <strong>Application Fee:</strong> NPR 1,000
        </li>
      </ul>

      <p>
        Applicants must submit proof of deposit of the application fee in the
        name of <strong>University of Nepal</strong> at:
        <br />
        <strong>Rastriya Banijya Bank, Darbarmarg Branch</strong>
        <br />
        <strong>Account No.: 1870100000304001</strong>
      </p>

      <br />

      <h5>How to Apply</h5>
      <ul>
        <li>
          <strong>Online Application:</strong>
          <br />
          Visit the University of Nepal website and complete the online
          application form:
          <br />
          <a href="https://unepal.edu.np/application-form">
            https://unepal.edu.np/application-form
          </a>
        </li>
        <li>
          <strong>Document Upload:</strong>
          <br />
          Upload scanned copies of all required supporting documents through the
          online system.
        </li>
        <li>
          <strong>In-Person Submission (Optional):</strong>
          <br />
          Applications with supporting documents may also be submitted in person
          at:
          <br />
          <strong>
            Admission Office, Master of Public Policy Program, University of
            Nepal
          </strong>
        </li>
      </ul>

      <br />

      <h5>Contact Information</h5>
      <p>For further information or inquiries, please contact:</p>
      <p>
        <strong>Academic Director</strong>
        <br />
        School of Public Policy
        <br />
        University of Nepal
        <br />
        Sanogaucharan, Kathmandu, Nepal
        <br />
        Phone: +977-9851163444
        <br />
        Email:{" "}
        <a href="mailto:rajendra.pandit@uon.edu.np">
          rajendra.pandit@uon.edu.np
        </a>
      </p>
    </>
  );
};

export default AdmissionOpen;
